import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import {Accordion, Card, Button, ListGroup, Badge} from 'react-bootstrap';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {
  ARRANGEMENT_TYPE_SLUG,
  CABINET_SLUG,
  DEPARTMENTS,
  getDepartmentChildren,
  getDepartmentForMenu, LESSON_TYPE_SLUG
} from '../../config';
import UserMenu from './UserMenu.jsx';
import Menu from './Menu.jsx';


const MenuNavLink = ({ root, title, param, counter, counter_value }) => {
 return (
      <NavLink to={ root + ( param !== '#' ? param + '/' : '' ) }
               exact
               activeClassName="font-weight-bold"
               className="nav-link" >
          { title }{' '}
          { counter_value > 0 && <MenuBadge counter={counter} value={counter_value} />}
      </NavLink>
 )
}

MenuNavLink.propTypes = {
  root: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  counter: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  counter_value: PropTypes.number.isRequired,
}

const MenuBadge = ({ counter, value }) => {
 return (
  <Badge variant={ counter.variant } title={ counter.title }>{ value }</Badge>
 )
}

MenuBadge.propTypes = {
  counter: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  value: PropTypes.number.isRequired,
}

const TopMenu = (props) => {
  let location = useLocation();
  const defaultActiveAccordionKey = location.pathname.split('/').filter(i => i.length > 0).slice(2)[0];

  const [menu, setMenu] = useState(null);

  const getAccordionSubMenu = (root, menuItem) => {
    function getMenuChildren(){
      const tree = menuItem.children;
      let list = [];

      for (const [key, value] of Object.entries(tree)) {
        let item = {...value, key};
        if (value.is_moderator) {
          if (props.is_moderator) list.push(item);
          continue;
        }
        if (value.is_staff) {
          if (props.is_staff) list.push(item);
          continue;
        }
        if (value.is_teacher) {
          if (props.is_teacher) list.push(item);
          continue;
        }
        list.push(item);
      }
      return list.map(i => <div key={i.key}>{ getSimpleSubMenu(root, i) }</div>)
    }

    return(<>
      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" role="button"
           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          { menuItem.title }
        </a>
        <div className="dropdown-menu">
          { getMenuChildren() }
        </div>
      </li>
    </>)
  }

  const getSimpleSubMenu = (root, menuItem, single=false) => {
    if (menuItem.old_version){
      let href = root + menuItem.key + '/';
      if (menuItem.key === 'accounts/transfers' || menuItem['item_key'] === 'stat/actions') {
        href='/' + props.lang + '/' + CABINET_SLUG + '/' + menuItem.key + '/';
      }
      return <a href={ href } className="nav-link">{ menuItem.title }</a>
    }
    return(
      <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
        <MenuNavLink root={ root }
                     param={ menuItem.key }
                     title={ menuItem.title }
                     counter={ menuItem.counter }
                     counter_value={ menuItem.counter ? props[menuItem.counter.key] : 0 }/>
      </li>
    )
  }


  useEffect(() => {
    const tree = getDepartmentForMenu(props.is_moderator, props.is_staff);
    const menuItems = [];
    for (const [key, value] of Object.entries(tree)) {
      let root = '/'+lang+'/' + CABINET_SLUG + '/';
      if (value.children){
        root = '/'+lang+'/' + CABINET_SLUG + '/' + value.key + '/';
        menuItems.push(getAccordionSubMenu(root, value));
      } else {
        menuItems.push(getSimpleSubMenu(root, value, true));
      }
    }
    setMenu(menuItems);
  }, []);


  return(
    <div className="top-menu container mb-3">
      <nav className="navbar navbar-dark navbar-expand-md">
        <ul className="navbar-nav mr-auto flex-row">
          <li className="nav-item mr-2">
            <a href={'/' + lang + '/'} title={ gettext('На главную') }>
                <img src="/static/base/images/home.png" alt="tabs" title={ gettext('На главную') }/>
            </a>
          </li>
          <li className="nav-item mr-2">
            <a href={'/' + lang + '/' + ARRANGEMENT_TYPE_SLUG + '/'}
               title={ gettext('Перейти в раздел Ноты и миди') }>
              <img src="/static/base/images/tabs.png" alt="tabs" title={ gettext('Ноты') }/>
            </a>
          </li>
          <li className="nav-item mr-2">
            <a href={'/' + lang + '/' + LESSON_TYPE_SLUG + '/'}
               title={ gettext('Перейти в раздел Обучение игре на пиано') }>
              <img src="/static/base/images/education.png" alt="education"
                   title={ gettext('Обучение игре на пиано') }/>
            </a>
          </li>
        </ul>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#topMenu"
                aria-controls="topMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="navbar-collapse collapse" id="topMenu">
          <div className={'d-md-none'}>
            <ul className="navbar-nav mr-auto">
              {menu}
            </ul>
          </div>
        </div>
        <div className='d-none d-md-inline-block'><UserMenu/></div>
      </nav>
    </div>
)
};

const mapStateToProps = (state) => {
  return {
    isAuth: state.auth.isAuth,
    lang: state.auth.lang,

    moderatorCounter: state.auth.moder_count,
    moderatorArrangementCounter: state.shop.arrangements_moder_count,
    moderatorLessonsCounter: state.shop.lessons_moder_count,

    arrangementCounter: state.shop.arrangements_count,
    lessonsCounter: state.shop.lessons_count,
    couponsCounter: state.auth.coupons_count,
    favoritesCounter: state.auth.favorites_count,
    cartCounter: state.auth.cart_count,
    notificationsCounter: state.auth.notifications_count,
    messagesCounter: state.auth.messages_count,
    commentsCounter: state.auth.comments_count,
    aphorismsCounter: state.auth.aphorisms_count,
    collectionsCounter: state.auth.collection_arrangements_count,
    playlistsCounter: state.auth.collection_playlists_count,
    authorsCounter: state.auth.collection_authors_count,
    genresCounter: state.auth.collection_genres_count,
    // userId: state.auth.id,

    is_moderator: state.auth.is_moderator,
    is_staff: state.auth.is_staff,
    is_seller: state.auth.is_seller,
    is_teacher: state.auth.is_teacher,
    is_disciple: state.auth.is_disciple,
  }
};

export default compose(
  connect(mapStateToProps, {}),
)(TopMenu);